// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__mnSf3","box":"WorkspacesBox_box__KQ-uu","node":"WorkspacesBox_node__1WOJ_"};